<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	
	<div class="page_header">
		<h1 class="heading">Manage Workflow Process</h1>
	</div>

	<app-filter></app-filter>
	<ng-template #content let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title"> Delete Confirmation</h4>
			<button type="button" class="btn-close" aria-label="Close"
				(click)="modal.dismiss('Cross click')">&times;</button>
		</div>
		<div class="modal-body">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
		</div>
		<div class="modal-footer">
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="modal.dismiss('Cross click')"
				style="width:80px;">No</button>
		</div>
	</ng-template>

	<div class="row">
		<div class="col-md-12">
			<!-- Table Actions -->
			<app-actions [actions]="WFRouteActions" (actionEvent)="doRoutesAction($event)"></app-actions>

			<!-- End Table Actions -->

			<div class="table-responsive">
				<table class="table table-sm custom_table">
					<thead class="thead-inverse">
						<tr class="hdclpse">
							<th>Select</th>
							<th class="bfr-end-col">Type</th>
                            <th class="bfr-end-col">Role From</th>
                            <th class="bfr-end-col">Action</th>
                            <th class="bfr-end-col">Role To</th>
                            <th class="bfr-end-col">Status To</th>
                            <th class="bfr-end-col">Priority</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let route of routes | paginate : { itemsPerPage: pageSize, currentPage: page }; let i = index">
							<td><input type="checkbox" value="{{item}}" (change)="onChecked($event,route)"></td>
							<td class="bfr-end-col">{{route.routetype}}</td>
                            <td class="bfr-end-col">{{route.rolefrom}}</td>
                            <td class="bfr-end-col">{{route.action}}</td>
                            <td class="bfr-end-col">{{route.roleto}}</td>
                            <td class="bfr-end-col">{{route.tostatus}}</td>
                            <td class="bfr-end-col">{{route.priority}}</td>
						</tr>
					</tbody>
				</table>
			</div>
            <div class="table_footer">
                <div class="row">
                <div class="col-2">
                    <div class="input-group mb-3 rm-brd" *ngIf="routes.length > 0" style="width: 125px !important; height: 30px !important">
                    <div class="input-group-prepend">
                        <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange(pageSize)">
                        <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{ key }}</option>
                    </select>
                    </div>
                </div>
                </div> 
                <div class="column" style="margin: 0 auto !important">
                    <span *ngIf="routes.length == 0 && isLoading == false">
                      <p style="text-align: center !important; margin-bottom: 15px; font-weight: bold;">No workflow routes found.</p>
                    </span>
                </div>    
                <div class="column pagination_row">
                <div *ngIf="routes.length > 0">
                    <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true" (pageChange)="pager($event)" style="float: right !important"></pagination-controls>
                </div>
                </div>
            </div>
		</div>
	</div>
</div>